import React from 'react';
import { IconProps } from '.';

const SvgCartClock = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path fill={color} d='M17.25 7.25V4h-1.5v4.75H20v-1.5h-2.75Z' />
      <path
        fill={color}
        fillRule='evenodd'
        d='M20.865 12.317A6.5 6.5 0 1 0 10.043 6.75H6.62l-.33-3H1.5v1.5h3.446l1.323 12h13.145l1.45-4.933ZM16.5 12.5a5 5 0 1 0 0-10 5 5 0 0 0 0 10Zm0 1.5c.865 0 1.691-.17 2.447-.476l-.655 2.226H7.613l-.827-7.5h3.257A6.501 6.501 0 0 0 16.5 14Z'
        clipRule='evenodd'
      />
      <path fill={color} d='M11 20a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM18 20a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z' />
    </svg>
  );
};

export default SvgCartClock;
